'use es6';

export const DISABLE_COOKIE_SUBMISSION = 'disableCookieSubmission';
export const LEGAL_CONSENT_OPTIONS = 'legalConsentOptions';
export const NOTIFY_HUBSPOT_OWNER = 'notifyHubSpotOwner';
export const ALLOW_COOKIE_RESET = 'allowCookieReset';
export const RENDER_RAW_HTML = 'renderRawHtml';
export const LANG = 'lang';
export const CSS = 'css';